/**
 * @generated SignedSource<<2ab14b72ce4a6024791d03fed0f562f5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type useBookingFeedbackMutation$variables = {
  bookingId: string;
  careReceiverMood: string;
  careReceiverMoodAdditionalText: string;
  customerEnergy: string;
  customerEnergyAdditionalText: string;
  activitiesPerformed: string;
};
export type useBookingFeedbackMutation$data = {
  readonly bookingFeedback: {
    readonly status: string | null;
  } | null;
};
export type useBookingFeedbackMutation = {
  variables: useBookingFeedbackMutation$variables;
  response: useBookingFeedbackMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "activitiesPerformed"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "bookingId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "careReceiverMood"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "careReceiverMoodAdditionalText"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "customerEnergy"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "customerEnergyAdditionalText"
},
v6 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "activitiesPerformed",
        "variableName": "activitiesPerformed"
      },
      {
        "kind": "Variable",
        "name": "bookingId",
        "variableName": "bookingId"
      },
      {
        "kind": "Variable",
        "name": "careReceiverMood",
        "variableName": "careReceiverMood"
      },
      {
        "kind": "Variable",
        "name": "careReceiverMoodAdditionalText",
        "variableName": "careReceiverMoodAdditionalText"
      },
      {
        "kind": "Variable",
        "name": "customerEnergy",
        "variableName": "customerEnergy"
      },
      {
        "kind": "Variable",
        "name": "customerEnergyAdditionalText",
        "variableName": "customerEnergyAdditionalText"
      }
    ],
    "concreteType": "BookingFeedbackPayload",
    "kind": "LinkedField",
    "name": "bookingFeedback",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useBookingFeedbackMutation",
    "selections": (v6/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useBookingFeedbackMutation",
    "selections": (v6/*: any*/)
  },
  "params": {
    "cacheID": "e7836fd65676012a0beb045fa13e2012",
    "id": null,
    "metadata": {},
    "name": "useBookingFeedbackMutation",
    "operationKind": "mutation",
    "text": "mutation useBookingFeedbackMutation(\n  $bookingId: GUID!\n  $careReceiverMood: String!\n  $careReceiverMoodAdditionalText: String!\n  $customerEnergy: String!\n  $customerEnergyAdditionalText: String!\n  $activitiesPerformed: String!\n) {\n  bookingFeedback(bookingId: $bookingId, careReceiverMood: $careReceiverMood, careReceiverMoodAdditionalText: $careReceiverMoodAdditionalText, customerEnergy: $customerEnergy, customerEnergyAdditionalText: $customerEnergyAdditionalText, activitiesPerformed: $activitiesPerformed) {\n    status\n  }\n}\n"
  }
};
})();

(node as any).hash = "c0c57047039496d01ee39dc6f5d82c33";

export default node;
